import ApiClient from "./repository";
import authstore from '@/store/modules/auth';

export default {
    async getPlaces(page, itemsPerPage, filter) {
        var client = await ApiClient.getClient();
        console.log("page",page);
        console.log("perpage",itemsPerPage);
        console.log("filter",filter)
        const params = new URLSearchParams();
        params.append("pageNumber", page);
        params.append("pageSize", itemsPerPage);
        params.append("searchCriteria", filter);

        const { data } = await client.post("/Place/SearchPlaces", {
            pageNumber:page,
            pagesize:itemsPerPage,
            searchCriteria:filter,
        });
        return {
            list: data.data,
            totalItems: data.count
        };
    },
    async getExitTransactions(page, itemsPerPage, filter) {
        var client = await ApiClient.getClient();
        page--;
        const { data } = await client.post("transactions/transactions", {
            page,
            itemsPerPage,
            filter
        });
        console.log(data);
        return {
            list: data.data,
            totalItems: data.totalItems
        };
    },
};